export default "__VITE_ASSET__B23wRkL___ 100w";